import { ApiModule } from "spiritweb.packages.web-account";

export default ApiModule.HttpService;
